<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 24 24">
    <title :id="iconName">{{ iconName }} icon</title>
    <g :fill="iconColor">
      <circle
        cx="20.25"
        cy="7.498"
        r="3.5" />
      <circle
        cx="13.25"
        cy="3.498"
        r="3" />
      <circle
        cx="6.25"
        cy="5.498"
        r="3" />
      <circle
        cx="2.75"
        cy="11.498"
        r="2.5" />
      <circle
        cx="4.25"
        cy="17.498"
        r="2.5" />
      <circle
        cx="9.25"
        cy="21.498"
        r="2" />
      <circle
        cx="14.625"
        cy="21.644"
        r="1.5" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "loading",
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  animation: rotation 1s infinite steps(24);
}

@keyframes rotation {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
